export default [
  {
    path: "data-export",
    component: () => import("@/pages/AdminPages/DataExportPage"),
  },
];
